import { PropType, reactive } from 'vue';
import BaseSetupService from '@/setup/BaseSetupService';
import TimeTicketWeekTempWorkerEntity from '@/entity/time-ticket/TimeTicketWeekTempWorkerEntity';
import TimeTicketWeekApiClient from '@/api/TimeTicketWeekApiClient';
import TimeTicketWeekApiTempWorker from '@/api/TimeTicketWeekApiTempWorker';
import { useNotif } from '@orion.ui/orion';
import TimeTicketWeekEntity from '@/entity/time-ticket/TimeTicketWeekEntity';

type Props = SetupProps<typeof TimeTicketMissionEndModalSetupService.props>

export default class TimeTicketMissionEndModalSetupService extends BaseSetupService<Props> {
	static readonly props = {
		timeTicketWeek: {
			type: Object as PropType<TimeTicketWeekTempWorkerEntity | TimeTicketWeekEntity>,
			required: true as const,
		},
	};

	readonly _modal?: OrionModal;

	private readonly state = reactive({ missionEndDate: undefined as Undef<Date> });

	get missionEndDate () {
		return this.state.missionEndDate;
	}

	set missionEndDate (val) { this.state.missionEndDate = val;}

	constructor (props: Props, _modal?: OrionModal) {
		super(props);
		this._modal = _modal;
	}

	protected onMounted () {
		const date = [...this.props.timeTicketWeek.days]
			.sort((a, b) => new Date(b.date).valueOf() - new Date(a.date).valueOf())
			.find(x => x.missing || (x.dayHours !== 0 || x.nightHours !== 0))?.date
    ?? this.props.timeTicketWeek.from;

		if (date) this.missionEndDate = new Date(date);
	}

	async validateMissionEndAsync () {
		this._modal?._loader()?.show(`Enregistrement...`);

		if (this.self.isTempWorker()) {
			await TimeTicketWeekApiTempWorker.update(this.props.timeTicketWeek.id, { endOfMissionDate: this.state.missionEndDate?.toPost() });
		} else if (this.self.isClient()) {
			await TimeTicketWeekApiClient.update(this.props.timeTicketWeek.id, { endOfMissionDate: this.state.missionEndDate?.toPost() });
		}
		useNotif.success(`La fin de mission a bien été enregistrée au ${this.state.missionEndDate?.toReadable()}`);
		this._modal?.trigger('missionEnded', this.missionEndDate);
	}
}
